<template lang='pug'>
ImportWizard(
  ref='wizard',
  :nextStep='nextStep',
  :currentTab.sync='currentTab'
  v-on='$listeners')
  template(v-if='importType === "default"')
    wizard-tab#workspaceId
      template(slot='label')
        | {{$t('importWorkspace.selectWorkspace')}}
      SelectWorkspace(
        ref='step1'
        @selected-workspace='handleWorkspaceUpdate($event.id)')
    wizard-tab#snapshot
      template(slot='label')
        | {{$t('importWorkspace.selectVersion')}}
      SelectSnapshot(
        ref='step2'
        v-if='stepData.workspaceId',
        :workspaceId='stepData.workspaceId'
        @selected-snapshot='stepData.snapshot = $event')
  template(v-else)
    wizard-tab#json
      template(slot='label')
        | {{$t('importWorkspace.selectJson')}}
      SelectJSON(ref='step1' @selected-json='stepData.json = $event')
  wizard-tab#edit
    template(slot='label')
      | {{$t('importWorkspace.selectImportMode')}}
    EditInformation(
      ref='step3',
      :snapshot='stepData.snapshot'
      @selected-type='stepData.edit = $event')
  wizard-tab#confirmation
    template(slot='label')
      | {{$t('importWorkspace.confirmation')}}
    ConfirmationStep(ref='step4', :finished='currentTab === "confirmation"' :loading='loading' :importError='importError')
</template>

<script>
import ImportWizard from '@/components/WorskspaceImportDialogs/ImportWizard'
import WizardTab from '@/components/Wizard/WizardTab'
import SelectWorkspace from '@/components/WorskspaceImportDialogs/WorkspaceImportSteps/default/SelectWorkspace'
import SelectSnapshot from '@/components/WorskspaceImportDialogs/WorkspaceImportSteps/default/SelectSnapshot'
import SelectJSON from '@/components/WorskspaceImportDialogs/WorkspaceImportSteps/json/SelectJSON'
import EditInformation from '@/components/WorskspaceImportDialogs/WorkspaceImportSteps/EditInformation'
import ConfirmationStep from '@/components/WorskspaceImportDialogs/WorkspaceImportSteps/ConfirmationStep'
export default {
  name: 'ImportDefault',
  props: ['importType'],
  components: {
    ImportWizard,
    WizardTab,
    SelectWorkspace,
    SelectSnapshot,
    SelectJSON,
    EditInformation,
    ConfirmationStep
  },
  watch: {
    currentTab () {
      // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
      if (this.currentTab === 'confirmation') {
        // console.log('currentTab === confirmation')
        this.$refs.wizard.disableTabsBefore()
        this.triggerImport()
      }
    }
  },
  computed: {
    nextStep () {
      return this.stepData[this.currentTab] !== null
    }
  },
  data () {
    return {
      activeTabIndex: 0,
      stepData: {
        workspaceId: null,
        json: null,
        snapshot: null,
        edit: null
      },
      loading: true,
      importError: {},
      currentTab: ''
    }
  },
  methods: {
    triggerImport () {
      this.loading = true
      setTimeout(() => {
        // console.log(`this.stepdata`, this.stepData)
        this.$emit(
          'finish-import',
          this.stepData,
          function (error) {
            this.importError = error
            // console.log(this.importError)
            this.loading = false
          }.bind(this)
        )
      }, 2000)
    },
    handleWorkspaceUpdate (workspace) {
      this.stepData.workspaceId = workspace
      this.stepData.snapshot = null
      this.stepData.edit = null
      this.$refs.wizard.disableTabsAfterIndex(0)
    }
  },
  created () {
    this.currentTab = this.importType === 'default' ? 'workspaceId' : 'json'
  }
}
</script>
